import type {USER_PREMIUM_LEVELS} from "@Utils/user.util";

export const PREMIUM_PRICING_PANEL_ID = 'PremiumPricingPanel';

export interface PremiumPricingPanelProps {
    modalId: string;
    onGoBack?: () => void;
    isTrial?: boolean;
}

export interface PremiumPricingPanelState {
    plans: Plan[];
    isWaitingForAJAXResponse: boolean;
    selectedCycle: PlanCycle;
    yotpoData: YotpoReviewsMeta | undefined;
}

export interface YotpoReviewsMeta {
    idYotpoProduct: number;
    reviewCount: number;
    averageStarRating: number;
}

export interface PlanCardProps {
    plan: Plan;
    isTrial: boolean;
    onCloseModal: () => void;
    isPopular?: boolean;
    containerSpacingClass?: string;
}

export interface Plan {
    priceId: number | string;
    name: string;
    description: string;
    price: number;
    currencyCode: string;
    level: USER_PREMIUM_LEVELS;
    features: PlanFeature[];
    cycle?: PlanCycle;
}

export interface PlanFeature {
    icon: string;
    description: string;
    isComingSoon?: boolean;
}

export enum PlanCycle {
    MONTHLY = 1,
    YEARLY = 12
}